export default {
  'signin.title': 'Authentication',
  signin: 'Sign in',
  signup: 'Log in',
  'info.signup':
    '  If you do not have an account yet. You can register by clicking on the button below.',
  password_reset: 'Reset your password? ',
  'login.authentication.failed':
    'Please check if your email and password are correct',
  'user.email': 'Email',
  'user.password': 'Password',
  'button.login': 'Sign In',
  'user.confirmPassword': 'Confirm Password',
  'pwd.reset': 'Reset Password',
  'error.invalidPassword': 'Invalid password',
  'error.invalidPin': 'Invalid pin',
  click: 'click here',
};
